// extracted by mini-css-extract-plugin
export default {"Badges":"IR3YxXVzwj1aQM0XyCri","h2":"tijpjMSc3MfQXUDhKEPC"};